import { Box, Button, Popover, Typography } from '@mui/material';

interface Key {
  main: string;
  sub: string;
}
interface DTMFButtonsProps {
  keys: Key[];
  handleDTMF: (key: string) => void;
  handleClose: () => void;
  open: boolean;
  anchorEl: HTMLElement | null;
  theme: any;
}

export const DTMFButtons: React.FC<DTMFButtonsProps> = ({
  keys,
  handleDTMF,
  handleClose,
  open,
  anchorEl,
  theme,
}) => (
  <Popover
    open={open}
    anchorEl={anchorEl}
    onClose={handleClose}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
  >
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 1,
        p: 1.5,
        maxWidth: 200,
      }}
    >
      {keys.map((k) => (
        <Button
          key={k.main}
          onClick={() => handleDTMF(k.main)}
          sx={{
            borderRadius: '12px',
            color: theme.palette.getContrastText(theme.palette.primary.main),
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
              backgroundColor: theme.palette.primary.dark,
            },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1rem',
            fontWeight: 'bold',
            minHeight: 48,
            minWidth: 48,
            p: 0.5,
          }}
        >
          <Typography variant="h6" sx={{ lineHeight: 1 }}>
            {k.main}
          </Typography>
          {k.sub && (
            <Typography
              variant="caption"
              sx={{
                fontSize: '0.625rem',
                color: theme.palette.grey[300],
                lineHeight: 1,
                mt: 0.3,
              }}
            >
              {k.sub}
            </Typography>
          )}
        </Button>
      ))}
    </Box>
  </Popover>
);
